import { call, select } from 'redux-saga/effects';
import { SignalingSocket } from 'services/signaling';
import { UserId } from 'features/users/types';
import { selectLocalUserId } from 'features/users/usersSlice';
import { logger } from 'utils/logger';

export function* stopRestreamingRequestSaga() {
  const userId: UserId = yield select(selectLocalUserId);
  logger.remote({ tier: 1 }).info(`Restreaming stop initiated by user: ${userId}`);

  yield call(SignalingSocket.send, {
    event: 'stopRestreamingRequest',
  });
}
